// extracted by mini-css-extract-plugin
export default {"Avatar":"VmFIg","Avatar_default":"NAIxT"};